import { Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import { Helmet } from "react-helmet-async";
import { RouteEnum, routes } from "./routes";
import NavMenu from "components/navMenu/NavMenu";
import { PageLoadingSpinner } from "components/pageLoadingSpinner/PageLoadingSpinner";

const AppRouter: React.FC = () => {
  // load stuff dynamically
  //   const [routes, setRoutes] = useState();
  //   useEffect(() => {
  //     fetch("https://app-name.hopin.to/routes.json", {})
  //       .then((res) => res.json())
  //       .then(({ results }) => setRoutes(results.routes));
  //   }, []);

  return (
    <Router>
      <NavMenu />
      <Suspense fallback={<PageLoadingSpinner />}>
        <Switch>
          {routes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              render={() => (
                <>
                  <Helmet>
                    <title>Money Workspace - {route.title}</title>
                  </Helmet>
                  <route.component />
                </>
              )}
            />
          ))}
          <Redirect to={RouteEnum.DASHBOARD} />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default AppRouter;
